// src/config/plotConfigs/polyShiftConfig.js

export const polyShiftConfig = {
  sections: [
    {
      fields: [
        {
          id: "geneType",
          label: "Gene type",
          type: "radio",
          options: [
            { value: "all", label: "All" },
            { value: "coding", label: "Coding" },
            { value: "noncoding", label: "Non-coding" },
            { value: "custom", label: "Custom" },
          ],
          tooltip:
            "Carry out the search using coding genes (default), non-coding genes, all genes or a custom list. If this is not set to coding then region has to be set to 'all'.",
          width: 4,
        },
        {
          id: "customTranscriptList",
          label: "Custom transcript list",
          type: "text",
          placeholder: "Enter custom transcript list",
          tooltip:
            "Carry out analysis on all genes or using a custom list (enter list of genes in input box, Transcript ID's not accepted).",
          width: 4,
          showIf: (settings) => settings.geneType === "custom",
        },
        {
          id: "colorPalette",
          label: "Color palette",
          type: "radio",
          options: [
            { value: "orange_purple", label: "Orange/Purple" },
            { value: "viridis", label: "Viridis" },
            { value: "plasma", label: "Plasma" },
            { value: "red_blue", label: "Red/Blue" },
          ],
          tooltip:
            "Select the color palette to use with the shift score heatmap.",
          width: 4,
        },
        {
          id: "colMin",
          label: "Color bar min",
          type: "number",
          placeholder: "Auto",
          tooltip:
            "Optionally manually set the minimum scale of the color bar, if left empty scaling will be automatic.",
          width: 3,
        },
        {
          id: "colMax",
          label: "Color bar max",
          type: "number",
          placeholder: "Auto",
          tooltip:
            "Optionally manually set the maximum scale of the color bar, if left empty scaling will be automatic.",
          width: 3,
        },

        {
          id: "zscoreCheck",
          label: "Use Z-score",
          type: "checkbox",
          tooltip: "Display Z-score in the analysis.",
          width: 2,
        },
        {
          id: "onlySigCheck",
          label: "Only significant",
          type: "checkbox",
          tooltip:
            "If this is selected only significant hits will be shown on the heatmap.",
          width: 2,
        },
        {
          id: "emailNotification",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 2,
        },
      ],
    },
  ],
};

export const polyShiftDefaults = {
  geneType: "all",
  customTranscriptList: "",
  colorPalette: "orange_purple",
  colMin: "",
  colMax: "",
  selectedSeqType: "riboseq",
  zscoreCheck: false,
  onlySigCheck: false,
  emailNotification: false,
  customControlName: "Control",
  customTreatmentName: "Treatment",
  plotType: "static",
  geneNo: "",
  customGeneList: "",
  minCov: "",
};

